import React, { useEffect, useState } from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';
import { ActionButton } from '../action-button/action-button';
import { ActionButtonLabel } from '../action-button-label/action-button-label';
import { ActionButtonIcon, } from '../action-button-icon/action-button-icon';
import { OWNERSHIP_STATUSES } from '../../../../widget';
import styles from './actions-panel.scss';
import { InfoOverlayAnimate } from './info-overlay';
const defaultProps = {
    onAllCardsButtonClick: noop,
    onBuyRentButtonClick: noop,
    onVideoInfoShow: noop,
    onShareVideoShow: noop,
    pauseVideo: noop,
    exitFullScreen: noop,
    isControlsShown: true,
};
export const ActionsPanel = (props) => {
    const { pauseVideo, onAllCardsButtonClick, onCommentsButtonClick, onVideoInfoShow, onShareVideoShow, exitFullScreen, areElementsRounded, canShowBuyRentButton, canShareVideo, canShowFullInfo, canShowAllCardsButton, canShowCommentsButton, buyRentButtonText, videoInfoFullText, videoInfoShortText, shareVideoFullText, shareVideoShortText, showAllCardsFullText, commentsFullText, commentsShortText, showAllCardsShortText, infoButtonAriaLabel, shareButtonAriaLabel, allCardsButtonAriaLabel, commentsButtonAriaLabel, shouldShowCommentsPimple, videoOwnershipStatus, isRTL, isFocusable, isControlsShown, } = {
        ...defaultProps,
        ...props,
    };
    const [isMainContentHidden, setIsMainContentHidden] = useState(!isControlsShown);
    const show = () => {
        setIsMainContentHidden(false);
    };
    const hide = () => {
        setIsMainContentHidden(true);
    };
    const handleAllCardsButtonClick = (event) => {
        pauseVideo();
        onAllCardsButtonClick(event);
    };
    const handleCommentsButtonClick = () => {
        onCommentsButtonClick();
    };
    const onBuyRentButtonClickHandler = (event) => {
        if (props.onBuyRentButtonClick) {
            pauseVideo();
            exitFullScreen();
            props.onBuyRentButtonClick(event);
        }
    };
    const getBuyRentIconName = () => {
        switch (videoOwnershipStatus) {
            case OWNERSHIP_STATUSES.YOU_BOUGHT_THIS:
                return 'film';
            case OWNERSHIP_STATUSES.YOU_RENTED_THIS:
                return 'timer';
            default:
                return 'dollar';
        }
    };
    useEffect(() => {
        if (isControlsShown) {
            if (isMainContentHidden) {
                show();
            }
        }
        else {
            hide();
        }
    }, [isControlsShown, isMainContentHidden]);
    const rtlClassConfig = {
        [styles.rtl]: isRTL,
        [styles.ltr]: !isRTL,
    };
    const actionButtonClasses = classnames(styles.actionButton, rtlClassConfig);
    return (React.createElement("section", { className: styles['main-content-wrapper'], "data-hook": "player-overlay-actions" },
        React.createElement(InfoOverlayAnimate, { when: !isMainContentHidden },
            React.createElement("div", { className: styles['main-content-inner'] },
                React.createElement("div", { className: classnames(styles.actions, rtlClassConfig) },
                    canShowBuyRentButton && (React.createElement(ActionButton, { className: classnames(actionButtonClasses, styles['buy-rent-button'], {
                            [styles['with-label']]: buyRentButtonText,
                        }), dataHook: "paid-access-button", isFocusable: isFocusable, onClick: onBuyRentButtonClickHandler, rounded: areElementsRounded },
                        buyRentButtonText && (React.createElement(ActionButtonLabel, { className: styles['button-label'], label: buyRentButtonText })),
                        React.createElement(ActionButtonIcon, { icon: getBuyRentIconName() }))),
                    canShowFullInfo && (React.createElement(ActionButton, { className: classnames(actionButtonClasses, styles.animatedButton, styles['video-info-button']), dataHook: "video-info-button", isFocusable: isFocusable, onClick: onVideoInfoShow, ariaLabel: infoButtonAriaLabel, rounded: areElementsRounded },
                        videoInfoFullText && (React.createElement(ActionButtonLabel, { className: styles['button-label'], label: videoInfoFullText, shortLabel: videoInfoShortText })),
                        React.createElement(ActionButtonIcon, { icon: "info" }))),
                    canShareVideo && (React.createElement(ActionButton, { className: classnames(actionButtonClasses, styles.animatedButton, styles['share-button']), dataHook: "share-button", isFocusable: isFocusable, onClick: onShareVideoShow, ariaLabel: shareButtonAriaLabel, rounded: areElementsRounded },
                        shareVideoFullText && (React.createElement(ActionButtonLabel, { className: styles['button-label'], label: shareVideoFullText, shortLabel: shareVideoShortText })),
                        React.createElement(ActionButtonIcon, { icon: "share" }))),
                    canShowAllCardsButton && (React.createElement(ActionButton, { className: classnames(actionButtonClasses, styles.animatedButton, styles['all-cards-button']), dataHook: "all-cards-button", isFocusable: isFocusable, onClick: handleAllCardsButtonClick, ariaLabel: allCardsButtonAriaLabel, rounded: areElementsRounded },
                        showAllCardsFullText && (React.createElement(ActionButtonLabel, { className: styles['button-label'], label: showAllCardsFullText, shortLabel: showAllCardsShortText })),
                        React.createElement(ActionButtonIcon, { icon: "spark" }))),
                    canShowCommentsButton && (React.createElement(ActionButton, { className: classnames(actionButtonClasses, styles.animatedButton, styles['chat-button']), dataHook: "chat-button", isFocusable: isFocusable, onClick: handleCommentsButtonClick, ariaLabel: commentsButtonAriaLabel, rounded: areElementsRounded },
                        commentsFullText && (React.createElement(ActionButtonLabel, { className: styles['button-label'], label: commentsFullText, shortLabel: commentsShortText })),
                        React.createElement("div", { className: styles['chat-big'] },
                            React.createElement(ActionButtonIcon, { icon: "chatBig" })),
                        React.createElement("div", { className: styles['chat-small'] },
                            React.createElement(ActionButtonIcon, { icon: "chatSmall" })),
                        shouldShowCommentsPimple && (React.createElement("div", { className: styles['chat-pimple'] })))))))));
};
//# sourceMappingURL=actions-panel.js.map